function toProgressNumber(value) {
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return null
  if (numeric < 0) return 0
  if (numeric > 100) return 100
  return Math.round(numeric)
}

export function resolveUnifiedProgress(...values) {
  const normalized = values
    .flat()
    .map(toProgressNumber)
    .filter((value) => value !== null)

  if (!normalized.length) return 0
  return Math.max(...normalized)
}

export function getCourseContentEntries(course) {
  const contents = []

  course?.modules?.forEach((module) => {
    module.lessons?.forEach((lesson) => {
      if (lesson.contents?.length > 0) {
        lesson.contents.forEach((content) => {
          contents.push(content)
        })
        return
      }

      contents.push(lesson)
    })
  })

  course?.standaloneLessons?.forEach((lesson) => {
    if (lesson.contents?.length > 0) {
      lesson.contents.forEach((content) => {
        contents.push(content)
      })
      return
    }

    contents.push(lesson)
  })

  const assessmentId = course?.assessmentId || course?.assessment_id
  if (course?.assessmentEnabled || assessmentId) {
    contents.push({ id: `assessment-${assessmentId}` })
  }

  return contents
}

export function getLocalCourseProgress(course, completedContents) {
  const allContents = getCourseContentEntries(course)
  if (!allContents.length) return 0

  const completedIds = new Set(completedContents || [])
  const completedCount = allContents.filter((content) => completedIds.has(content.id)).length

  return resolveUnifiedProgress((completedCount / allContents.length) * 100)
}

export function getCompletedContentIdsFromCompletedLessons(course, completedLessonIds) {
  const lessonIdSet = new Set((completedLessonIds || []).map((id) => String(id)))
  if (!lessonIdSet.size) return []

  const completedContentIds = []

  const appendLessonCompletion = (lesson) => {
    const lessonId = String(lesson?.id || '')
    if (!lessonId || !lessonIdSet.has(lessonId)) return

    if (Array.isArray(lesson.contents) && lesson.contents.length > 0) {
      lesson.contents.forEach((content) => {
        if (content?.id) completedContentIds.push(content.id)
      })
      return
    }

    if (lesson?.id) completedContentIds.push(lesson.id)
  }

  course?.modules?.forEach((module) => {
    module?.lessons?.forEach(appendLessonCompletion)
  })

  course?.standaloneLessons?.forEach(appendLessonCompletion)

  return Array.from(new Set(completedContentIds))
}
